import { showNotification } from '@mantine/notifications';


export function popNotification(title : string, message : string , color : string, icon?:any) : void {
    showNotification({
    title,message,color,icon
  })
}

